var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillInInformationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_60880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33091 0.0112367H11.6616C13.8775 -0.0375716 16.2789 0.64184 17.7939 2.20566C19.3596 3.72067 20.0371 6.12203 19.9902 8.33793V11.6686C20.0371 13.8845 19.3596 16.2859 17.7939 17.8009C16.2789 19.3667 13.8775 20.0441 11.6616 19.9973H8.33091C6.11502 20.0441 3.71365 19.3667 2.19864 17.8009C0.632871 16.2878 -0.0445881 13.8865 0.00226782 11.6706V8.33988C-0.0445881 6.12204 0.632871 3.72067 2.19864 2.20566C3.71365 0.64184 6.11502 -0.0375716 8.33091 0.0112367Z",
    fill: "#724404"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.19833 2.20645C0.720411 3.63751 0.0331904 5.85731 0.00195312 7.96583C2.69617 7.96583 4.88083 5.77922 4.88083 3.085C4.88083 2.2494 4.66998 1.46261 4.30099 0.775391C3.50834 1.12486 2.78598 1.59927 2.19833 2.20645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8617 8.33056L9.37756 13.8147C9.27799 13.9142 9.15695 13.9904 9.02419 14.0392L5.52561 15.2809C5.0141 15.4624 4.52016 14.9646 4.70759 14.455L5.97855 10.9877C6.02541 10.8569 6.10155 10.7397 6.19917 10.6421L11.6852 5.15412C12.308 4.53132 13.3193 4.53523 13.946 5.16193L14.8539 6.06976C15.4806 6.69451 15.4845 7.70777 14.8617 8.33056ZM8.38773 13.4418L6.57206 11.6261C6.44711 11.5011 6.24407 11.5011 6.11912 11.6261C5.99417 11.751 5.99417 11.9541 6.11912 12.079L7.93479 13.8947C8.05974 14.0197 8.26278 14.0197 8.38773 13.8947C8.51268 13.7698 8.51268 13.5667 8.38773 13.4418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.9455 5.16156C13.3852 4.60124 12.5145 4.54072 11.8917 4.97999C12.3017 6.50867 13.4555 7.73278 14.9432 8.24038C15.4801 7.61369 15.4508 6.66681 14.8534 6.06939L13.9455 5.16156ZM5.52512 15.2805L8.29548 14.2946C7.93235 13.8768 7.39546 13.6132 6.79804 13.6132C5.85897 13.6132 5.07413 14.2653 4.86719 15.1399C5.03314 15.2961 5.27718 15.3703 5.52512 15.2805Z",
    fill: "#BD9761"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_60880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillInInformationIcon);
export default __webpack_public_path__ + "static/media/fill_in_information_icon.f7f800deec7638ed7d9dd35376fd4a8b.svg";
export { ForwardRef as ReactComponent };